export const DOCUMENT_TYPES = [
  "tax_status_certificate",
  "valid_id",
  "proof_of_address",
  "articles_of_incorporation",
  "address_legal_representative",
  "id_legal_representative",
  "commercial_registry"
] as const;

export type DocumentType = (typeof DOCUMENT_TYPES)[number];

export const DOCUMENT_TYPES_BY_ENTITY: Record<
  "moral" | "physical",
  Partial<Record<string, DocumentType>>
> = {
  physical: {
    constancia_fiscal: "tax_status_certificate",
    identificacion_oficial: "valid_id",
    comprobante_domicilio: "proof_of_address"
  },
  moral: {
    constancia_fiscal: "tax_status_certificate",
    folio_mercantil: "commercial_registry",
    comprobante_domicilio: "proof_of_address",
    acta_constitutiva: "articles_of_incorporation",
    identificacion_representante: "id_legal_representative",
    comprobante_domicilio_representante: "address_legal_representative"
  }
};
